import { configureStore } from '@reduxjs/toolkit';
import authReducer from './Login/authslice';
import createPlantReducer from './Features/Plants/CreatePlantSlice';
import plantReducer from './Features/Plants/plantSlice';
import summaryReducer from './Features/Summary/SummarySlice';

export const store = configureStore({  reducer: {
    auth: authReducer,
    plant: createPlantReducer,
    plantInfo: plantReducer,
    summary: summaryReducer,
  }
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
